export const INITIAL_BACKEND_VARIABLES: Record<string, string> = {
  '--backend-colors-extra': '',
  '--backend-colors-primary': '#303030',
  '--backend-colors-secondary': '#80ced7',
  '--backend-colors-title': '#2e2e2e'
};
